class WhyBospAccordion extends HTMLElement {
  /** @type {AbortController | null} */
  #controller = null;

  /** @type {string} */
  #fallbackImage = '';

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    const image = this.#getMediaImage();
    if (image) {
      this.#fallbackImage =
        this.dataset.fallbackImage || image.getAttribute('src') || image.currentSrc || image.src;
    }

    this.querySelectorAll('details[data-why-bosp-row]').forEach((details) => {
      details.addEventListener('toggle', this.#handleToggle, { signal });
    });

    this.#syncImage();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
  }

  /** @type {EventListener} */
  #handleToggle = (event) => {
    const details = event.target;

    if (!(details instanceof HTMLDetailsElement) || !details.hasAttribute('data-why-bosp-row')) {
      return;
    }

    if (details.open) {
      this.querySelectorAll('details[data-why-bosp-row]').forEach((row) => {
        if (row !== details) {
          row.open = false;
        }
      });
    }

    this.#syncImage();
  };

  #getMediaImage() {
    const image = this.querySelector('.why-bosp__media img');

    return image instanceof HTMLImageElement ? image : null;
  }

  #syncImage() {
    const image = this.#getMediaImage();

    if (!image || !this.#fallbackImage) {
      return;
    }

    const openRow = this.querySelector('details[data-why-bosp-row][open]');
    const rowImage = openRow instanceof HTMLDetailsElement ? openRow.dataset.rowImage : '';
    const nextSrc = rowImage || this.#fallbackImage;

    if (!nextSrc) {
      return;
    }

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = nextSrc;
  }
}

if (!customElements.get('why-bosp-accordion')) {
  customElements.define('why-bosp-accordion', WhyBospAccordion);
}
